import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ComissaoService } from '../comissao.service';
import { GrupoComissao } from '../models/comissao';

@Component({
  selector: 'app-grupo-comissao',
  templateUrl: './grupo-comissao.component.html',
  styleUrls: ['./grupo-comissao.component.scss']
})
export class GrupoComissaoComponent implements OnInit {
  
  constructor(private comissaoService : ComissaoService, private router: Router, private route: ActivatedRoute, private activateRoute: ActivatedRoute) { }

  public listaGruposComissao: GrupoComissao[];
  
  ngOnInit(): void {
     this.getGruposComissao();    
  }

  getGruposComissao(){
    this.comissaoService.getGruposComissao().subscribe(
      (res) => {
        if (res) {            
          this.listaGruposComissao = res; 
        }
      },
      err => {
        console.log("GrupoComissaoList - GruposComissao");
        console.log(err);
      }
    );
  }

}
